// extracted by mini-css-extract-plugin
export default {"NoteMark":"InfoClick_NoteMark__ppScP","opacity":"InfoClick_opacity__2TBpM"};